module.exports = __webpack_public_path__ + "static/media/debugger89.54be600a.png";